
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';

import * as redAguaAllActions from '../../actions/';
import { Action } from '@ngrx/store';
import { MapaService } from 'src/app/services/SicarMap/MapaService.service';

@Injectable()
export class redAguaEffects {

    constructor(
    private actions$: Actions,
    private mapService: MapaService
    ) {}

    @Effect()
    SetRedAguaAction: Observable<Action> = this.actions$.pipe(
        ofType(redAguaAllActions.SET_RED_AGUA),
        switchMap(() => {
            // this.mapService.getMapaBaseComplete();
            return this.mapService.RedAguaMapImage.pipe(
                map((layer: any) => new redAguaAllActions.SetRedAguaSuccesAction()),
                catchError(   error => of (new redAguaAllActions.SetRedAguaFailureAction( error))
                )
            );
        })
      );

    @Effect({ dispatch: false })
    VisibleRedAction: Observable<any> = this.actions$.pipe(
        ofType(redAguaAllActions.VISIBLE_RED),
            map((Datos) => {
                this.mapService.visualizarRed();
            })
        );

    @Effect({ dispatch: false })
    HiddenRedAction: Observable<any> = this.actions$.pipe(
        ofType(redAguaAllActions.HIDDEN_RED),
            map((Datos) => {
                this.mapService.ocultarRed();
            })
        );
}
